// Get Products

import Products from '@/services/Products'
import SalesChannels from '@/services/SalesChannels'
export default {
    data() {
        return {
            products: []
        }
    },
    methods: {
        getProducts () {
            this.products =[]
            Products.get().then(res => {
                if (res.status==200)
                    this.products=res.data
            })
        },
    }
}